import { APPOINTMENT_TYPE } from "features/appointment/types";

export interface Customer {
	id: number;
	username: string;
	fullName: null | string;
	avatar: null | string;
	phoneNumber: null | string;
	email: null | string;
	idCard: null | string;
	gender: number;
	birthday: null | string;
	status: STATUS;
	userType: number;
	address: null | string;
	title: string | null;
	createdAt?: string;
	updatedAt?: string;
	isRemoved: boolean;
	province?: number;
	ward?: number;
	district?: number;
	userAddress?: queryCustomerAddress | null;
	identify?: Identify;
}

export interface Identify {
	[IDENTIFICATION_TYPE.ID]: string;
	[IDENTIFICATION_TYPE.PASSPORT_NUMBER]: string;
	[IDENTIFICATION_TYPE.DRIVER_LICENSE]: string;
}

export enum IDENTIFICATION_TYPE {
	ID = "id",
	PASSPORT_NUMBER = "passport_number",
	DRIVER_LICENSE = "driver_license",
}

export interface ResponseCustomer {
	id: number;
	username: string;
	fullName: null | string;
	avatar: null | string;
	phoneNumber: null | string;
	email: null | string;
	idCard: null | string;
	gender: number;
	birthday: null | string;
	status: STATUS;
	userType: number;
	address: null | string;
	title: string | null;
	createdAt?: string;
	updatedAt?: string;
	isRemoved: boolean;
	province?: number;
	ward?: number;
	district?: number;
	userAddress?: CustomerAddress | null;
	referral?: {
		id?: number;
		fullName?: string;
	};
}

export interface CustomerAddress {
	province?: Address;
	ward?: Address;
	district?: Address;
}

export interface queryCustomerAddress {
	province?: number;
	ward?: number;
	district?: number;
}

export interface Address {
	id: number;
}

export interface PersonalAppointmentQueryParams {
	id: number;
	skip: number;
	take: number;
	textSearch?: string | null;
	startDate?: string | null;
	endDate?: string | null;
	status?: string | null;
	language?: string | null;
	showroom?: number | null;
	type?: APPOINTMENT_TYPE | null;
}

export interface PersonalPurchaseQueryParams {
	id: number;
	skip: number;
	take: number;
	bookingId?: string | null;
	startDate?: string | null;
	endDate?: string | null;
	status?: string | null;
}

export interface CustomerQueryParams {
	fullName?: string | null;
	phoneNumber?: string | null;
	email?: string | null;
	skip: number;
	take: number;
	status?: STATUS | null;
	isRemoved?: boolean | null;
}

export interface LoyaltyPoints {
	total?: number;
	totalEarned?: number;
	totalSpending?: number;
}

export enum STATUS {
	ENABLE = "enable",
	DISABLE = "disable",
}

export interface CsvFileType {
	fileUrl: string;
}
